import axios from "./api";
import publicAxios from "./publicApi";

const User = {
  Login(body) {
    return axios.post("/business/auth/login", body);
  },
  Register(body) {
    return axios.post("/business/auth/register", body);
  },
  AdminRegister(body) {
    return axios.post("/admin/register", body);
  },
  VerifyUnique(body) {
    return publicAxios.post("/business/auth/verify-unique", body);
  },
  ResetPassword(body) {
    return axios.post("/business/auth/change-password", body);
  },
  ResetPasswordRequest(body) {
    return axios.post("/business/password-reset/request", body);
  },
  ResetPasswordChange(body) {
    return axios.post("/business/password-reset/change", body);
  },
  addAccount(data) {
    return axios.post("/business/payment/stripe-account", data);
  },
};

export default User;
